module.exports = __webpack_public_path__ + "static/media/report_tag_shortened.b6067cce.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/gtmobile/src/report_tag_shortened.gif
// module id = 519
// module chunks = 0